module.exports = __webpack_public_path__ + "static/media/refillEmptyCartMSg.f75b42f9.png";